"use strict";var nextComponentIdProvider =
require("@internal/components-util")._P_;

function GlobalComponentsContext(out) {
  this.p_ = {};
  this.ax_ = undefined;
  this.aL_ = nextComponentIdProvider(out);
}

module.exports = GlobalComponentsContext;